import * as React from 'react';
export const KISvg = React.forwardRef(function KISvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M14 14H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 8V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M10 8H6a2 2 0 1 1 4 0ZM6 4h4v1H6V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 10h16v1H0v-1Zm0-2h16v1H0V8Zm.268 5A1.99 1.99 0 0 1 0 12h16c0 .364-.097.706-.268 1H.268Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillOpacity: 0.1,
        d: 'M14 14H2a2 2 0 0 1-2-2V8h1v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8h1v4a2 2 0 0 1-2 2Z',
      }),
    ),
  );
});
KISvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var KI = {
  category: 'flag',
  colorable: false,
  name: 'KI',
  svg: KISvg,
};
